import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { IntegrationSystem } from '@/shared/types';

import { createLegacyRedirectRoutes, createSystemRoutes, RoutesBySystem } from '@/router/utils';

import { IAC_ROUTES, IAC_ROUTES_LEGACY } from './config';

const CriminalRecordSearchAll = lazy(() => import('../pages/services/CriminalRecordSearchAll'));
const IACCheckForm = lazy(() => import('../pages/services/ExtractionCheck'));
const ExtendedCriminalRecordExtract = lazy(() => import('../pages/services/ExtendedCriminalRecord'));
const ExtractRedelivery = lazy(() => import('../pages/services/ExtractRedelivery'));

const iacSystemComponents: Record<
  keyof RoutesBySystem<IntegrationSystem.IAC>,
  React.LazyExoticComponent<React.FC<any>>
> = {
  CRIMINAL_RECORD_SEARCH_ALL: CriminalRecordSearchAll,
  CRIMINAL_RECORD_SEARCH: IACCheckForm,
  EXTENDED_CRIMINAL_RECORD_EXTRACT: ExtendedCriminalRecordExtract,
  EXTRACT_REDELIVERY: ExtractRedelivery,
};

export const IACRouter: RouteObject = createSystemRoutes(IntegrationSystem.IAC, IAC_ROUTES, iacSystemComponents);

export const IacLegacyRoutes = createLegacyRedirectRoutes(IAC_ROUTES_LEGACY);
